import { baseUrl } from './API';

export const systemAPI = baseUrl + '/apaas-system-service/';
export const resourceAPI = baseUrl + '/grt-resource-manage-service';
export const platformAPI = baseUrl + '/grt-platform-manage-service';
export const engineAPI = baseUrl + '/business-engine-service';
export const analysisAPI = baseUrl + '/grt-resource-analysis-service';
export const aiResourceAPI = baseUrl + '/grt-resource-manage-ai';
export const bbsAPI = baseUrl + '/grt-bbs-service';
export const courseReviewAPI = baseUrl + '/grt-course-review-service';
export const tradeAPI = baseUrl + '/grt-trade-service';
export const liveAPI = baseUrl + '/grt-live-service';
export const platformLiveAPI = baseUrl + '/grt-live-platform-service';
export const userCenterAPI = baseUrl + '/grt-user-center-service';
export const dynamicFieldAPI = baseUrl + '/grt-dynamic-field-service';
export const engineConfigAPI = baseUrl + '/business-engine-config-service';
export const aiAPI = baseUrl + '/grt-ai';
export const dpaasAPI = baseUrl + '/dpaas-data-api';
export const studyArchivesAPI = baseUrl + '/grt-study-archives-service';
export const ragflowAPI = baseUrl + '/grt-ragflow';
export const knowledgeAPI = baseUrl + '/grt-knowledge-graph-service';
export const studentAPI = baseUrl + '/grt-student-service';
export const modelAPI = baseUrl + '/grt-model-service';
export const urgeLearnAPI = baseUrl + '/grt-urge-learn-service';
export const applicationMarketAPI = baseUrl + '/grt-application-market-service';
export const tenantManageAPI = baseUrl + '/grt-tenant-manage-service';
export const userAPI = baseUrl + '/grt-user-service';
export const pointAPI = baseUrl + '/grt-point-service';


export default {
    systemAPI,
    resourceAPI,
    platformAPI,
    engineAPI,
    analysisAPI,
    aiResourceAPI,
    bbsAPI,
    courseReviewAPI,
    tradeAPI,
    liveAPI,
    platformLiveAPI,
    userCenterAPI,
    dynamicFieldAPI,
    engineConfigAPI,
    aiAPI,
    dpaasAPI,
    studyArchivesAPI,
    ragflowAPI,
    knowledgeAPI,
    studentAPI,
    modelAPI,
    urgeLearnAPI,
    applicationMarketAPI,
    tenantManageAPI,
    userAPI,
    pointAPI
};
